<template>
    <v-container class="pa-0 ma-0" fluid>
      <v-row class="mb-0 pb-0">
        <v-col cols="10" md="6">
            <v-text-field
              label=""
              placeholder="Buscar..."
              @keyup.enter="search()"
              filled
              dense
              hide-details
              class="caption"
              ref="prod"
            ></v-text-field>
        </v-col>
        <v-col cols="2" md="6" class="my-2">
          <v-btn  tile medium color="primary" icon @click.prevent="search()">
            <v-icon medium>fa-search</v-icon>
          </v-btn>          
        </v-col>
      </v-row>
			<v-row class="px-0 py-0">
				<v-col cols=12 >
          <v-data-table
            dense
            :headers="headers"
            :items="filtro"
            class="elevation-2"
            :hide-default-header="false"
            min-height="200px"
            height="500px"
            :fixed-header="true"

            :page.sync="page"
            :items-per-page="itemsPerPage"
            hide-default-footer
            @page-count="pageCount = $event"

            :disable-pagination='false'
            :loading="loadGrid"
           
            :mobile-breakpoint=100
          >
            <template v-slot:top>
              <v-toolbar flat dense color="white">
                <v-dialog v-model="dialog"  width="80vw"  scrollable persistent>
                  <Producto 
                    :idProducto="idProducto"

                    @close="close()"
                    @reload="loadItems()"
                    :key="keyProd"
                  >
                  </Producto>
                </v-dialog>
              </v-toolbar>
            </template>
<!--
            <template v-slot:header="{props}">
              <thead class="v-data-table-header">
              <tr >
                  <th
                    role="columnheader" scope="col" :aria-label="header.text" 
                    v-for="header in props.headers"
                    :key="header.text"
                    class="text-truncate body-2 primary white--text "
                    :class="header.class "
                    :align="header.align"
                    :width="header.width"
                    v-text="header.text"
                  />
              </tr>
              </thead>
            </template>
-->
            <template v-slot:item="{item,isSelected,select,headers} ">
              <tr class="body-2">
                <template v-for="(h, idx) in headers" >
                  <td v-if="h.value=='estado'"  :align="h.align" :key="idx" :class="['caption', h.class]"> 
                    <v-simple-checkbox dense :value="item[h.value]?true:false" disabled></v-simple-checkbox>
                  </td>
                  <td v-else-if="h.value=='fechaPrecio'" :align="h.align" :key="idx" :class="['caption', h.class]" >
                    {{item[h.value] | DDMMAAAA_HHMM}}
                  </td>
                  <td v-else-if="h.value!='actions'" :align="h.align" :key="idx" :class="['caption', h.class]" v-text="item[h.value]" />
                  <td v-else :align="h.align" :key="idx" :class="[ h.class]" class="px-1">
                    <v-icon
                      small
                      class="mx-3"
                      @click="editItem(item)"
                    >
                      fa fa-pencil
                    </v-icon>
                    <v-icon
                      small
                      class="mx-3"
                      @click="deleteItem(item)"
                    >
                      fa fa-trash-o
                    </v-icon>
                  </td>
                </template> 
              </tr>
            </template>
          </v-data-table>
        </v-col>
        <v-col cols=12>
            <div class="text-center pt-2">
              <v-pagination v-model="page" :length="pageCount"></v-pagination>
            </div>
        </v-col>

      </v-row>
    </v-container>
</template>
<script>
  import Producto from '@/components/Productos/Producto'

  import {mapGetters} from 'vuex'

  export default {
    name: 'Productos',

    components: {
      Producto
    },

    data: () => ({
      t:null,

      dialog:false,
      keyProd:0,

      producto:"",
      loadGrid:false,

      headers: [
        { text: 'COD',align: 'start',sortable: true, value: 'codigo' },
        { text: 'Descrip.' ,align: 'start',sortable: true, value: 'des'},
        { text: 'Marca' ,align: 'start',sortable: true, value: 'marca'},
        { text: 'Categoria' ,align: 'start',sortable: true, value: 'categoria'},
        { text: 'Precio' ,align: 'end',sortable: false, value: 'precio'},
        { text: 'F Precio', align: 'end', sortable: true, value:'fechaPrecio'},
        { text: 'Estado' ,align: 'center',sortable: false, value: 'estado'},
        { text: ''       ,align: 'center'  ,sortable: false, value: 'actions', width:"85px" },
      ],
      items:[],

      editedIndex: -1,
      editedItem: {
        idMarca: 0,
        marca: '',
      },
      defaultItem: {},

      idProducto:0,


      page: 1,
      pageCount: 0,
      itemsPerPage: 100,


    }),
    created: function () {
      console.log("Componente creado")
      //this.initialize()
    },
    mounted: function () {
      console.log("Componente mondado")
      this.loadItems()
    },
    watch: {
    },

    methods: {
      async initialize () {


      },
      close (){
        this.dialog=false
        
      },

      search(){
        this.producto=this.$refs.prod.$refs.input.value
      },

      editItem (item) {
        this.keyProd++

        console.log("edit item-->",item.id)
        this.idProducto=item.id
        
        this.dialog = true
      },

      deleteItem (item) {
        //const index = this.items.indexOf(item)
        //confirm('Seguro que desea eliminar prod seleccionado?') && this.items.splice(index, 1)
        alert("No esta perminitido eliminar articulos")
      },

      async loadItems (){
        let opt={
            method: 'GET', 
            mode: 'cors'
          }
        let response = await fetch(`${this.ROOT_API}productos`, opt);

        if (response.ok){
          let r=await response.json()
          this.items=r.map(item => {
            return {
              id:item.id,
              codigo:item.codigo,
              des:item.des,
              precio:item.precio.toFixed(2),
              estado:item.estado,
              marca:item.marca,
              categoria:item.categoria,
              fechaPrecio:item.modified_price
            }
          })
        }

      }


    },
    computed: {
      ...mapGetters(['SESSION','ROOT_API']),

      filtro: function(){
        console.log("prod--> ",this.producto)
        this.loadGrid=true
        if (this.producto.length==0) {
          this.loadGrid=false
          return this.items  
        }
        let r=this.items.filter( item => item.codigo.toLowerCase().includes(this.producto.toLowerCase()) || item.des.toLowerCase().includes(this.producto.toLowerCase()) )
        this.loadGrid=false
        return r//((r && r.length>0)  ? r.map(function(i) { return parseFloat(i.importe) }).reduce((res, item) => res=res + item) : 0).toFixed(2)
      },
    },
  }
</script>

<style scoped>

</style>
